// src/services/filterService.ts
import { apiService } from './api';
import type { PersonSecurityData } from '../types/person';

class PeopleService
{
  /**
   * Obtiene la informacion del usuario
   */
  async getPeopleData(): Promise<PersonSecurityData>
  {
    try
    {
      const response = await apiService.get<PersonSecurityData>(`/Person/GetPeopleData`);
      return response;
    }
    catch (error)
    {
      console.error('Error getting filter options:', error);
      throw error;
    }
  }

  /**
   * Obtiene la informacion del posiciones de usuarios
   */
  async GetPositions(): Promise<PersonSecurityData>
  {
    try
    {
      const response = await apiService.get<PersonSecurityData>(`/Positions/GetPositions
`);
      return response;
    }
    catch (error)
    {
      console.error('Error getting filter options:', error);
      throw error;
    }
  }
}

export const peopleService = new PeopleService();
